import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { UserStyles } from '../users/UserStyles';
import moment from 'moment'

const useStyles = makeStyles({
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});


function ViewAdmin(props) {
  const classes = useStyles();

  return (
    <>
      <Paper style={UserStyles.padding}>
        <h3 style={UserStyles.headingColor}>User Details</h3>
        <Typography variant="h6" component="h2" style={UserStyles.headingColor}>
          First Name
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          {props.admin[0].first_name}
        </Typography>
        <Typography variant="h6" component="h2" style={UserStyles.headingColor}>
          Last Name
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          {props.admin[0].last_name}
        </Typography>

        <Typography variant="h6" component="h2" style={UserStyles.headingColor}>
          Email
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          {props.admin[0].email}
        </Typography>
        <Typography variant="h6" component="h2" style={UserStyles.headingColor}>
          Created  At
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
      
          {
        moment(props.admin[0].date_created).format('MM-DD-YYYY')

}
        </Typography>

      </Paper>
    </>
  )
}
const mapStateToProps = (state, ownProps, number) => ({
  admin: state.dashboardReducer.selectedViewData
})

export default connect(mapStateToProps, null)(ViewAdmin);